// frontend/src/layouts/Admin.jsx
import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar/Sidebar';
import AdminNavbar from '../components/Navbars/AdminNavbar';
import ProtectedRoute from '../components/ProtectedRoute';
import routes from '../routes';

function Admin() {
  const location = useLocation();
  const mainContent = React.useRef(null);

  const getBrandText = (path) => {
    // Primero buscar en rutas principales
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].path && path.indexOf(routes[i].layout + routes[i].path) !== -1) {
        return routes[i].name;
      }
      // Buscar en submenús
      if (routes[i].submenu) {
        for (let j = 0; j < routes[i].submenu.length; j++) {
          if (path.indexOf(routes[i].submenu[j].layout + routes[i].submenu[j].path) !== -1) {
            return routes[i].submenu[j].name;
          }
        }
      }
    }
    return 'Dashboard';
  };

  // ✅ CORREGIDO: Ahora usa ProtectedRoute para cada ruta
  const getRoutes = (routes) => {
    const allRoutes = [];
    
    routes.forEach((prop) => {
      // Agregar ruta principal
      if (prop.component) {
        allRoutes.push(
          <Route 
            path={prop.path} 
            element={
              <ProtectedRoute permission={prop.permission}>
                <prop.component />
              </ProtectedRoute>
            } 
            key={prop.path} 
          />
        );
      }
      
      // Agregar rutas de submenú
      if (prop.submenu) {
        prop.submenu.forEach((subProp) => {
          allRoutes.push(
            <Route 
              path={subProp.path} 
              element={
                <ProtectedRoute permission={subProp.permission}>
                  <subProp.component />
                </ProtectedRoute>
              } 
              key={subProp.path} 
            />
          );
        });
      }
    });
    
    return allRoutes;
  };

  useEffect(() => {
    if (window.innerWidth >= 1200) {
      document.body.classList.add('g-sidenav-show', 'g-sidenav-pinned');
    } else {
      document.body.classList.remove('g-sidenav-show', 'g-sidenav-pinned');
    }

    const handleResize = () => {
      if (window.innerWidth >= 1200) {
        document.body.classList.add('g-sidenav-show', 'g-sidenav-pinned');
      } else {
        document.body.classList.remove('g-sidenav-pinned');
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <Sidebar routes={routes} />

      <main 
        className="main-content position-relative max-height-vh-100 h-100 border-radius-lg" 
        ref={mainContent}
      >
        <div className="min-height-300 bg-primary position-absolute w-100"></div>

        <AdminNavbar brandText={getBrandText(location.pathname)} />

        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
        </Routes>

        <footer className="footer pt-3">
          <div className="container-fluid">
            <div className="row align-items-center justify-content-lg-between">
              <div className="col-lg-6 mb-lg-0 mb-4">
                <div className="copyright text-center text-sm text-muted text-lg-start">
                  © {new Date().getFullYear()}, hecho con{' '}
                  <i className="fa fa-heart"></i> por{' '}
                  <a href="#equipo" className="font-weight-bold">
                    mas+
                  </a>
                </div>
              </div>
              <div className="col-lg-6">
                <ul className="nav nav-footer justify-content-center justify-content-lg-end">
                  <li className="nav-item">
                    <a href="#equipo" className="nav-link text-muted">
                      Equipo
                    </a>
                  </li>
                  <li className="nav-item">
                    <a href="#soporte" className="nav-link text-muted">
                      Soporte
                    </a>
                  </li>
                  <li className="nav-item">
                    <a href="#licencia" className="nav-link pe-0 text-muted">
                      Licencia
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </footer>
      </main>
    </>
  );
}

export default Admin;
